import { actionTypes } from './actions';
import initialState from './initialState';

export default function searchInnReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state.set('loading', true).set('data', null).set('error', null);
    case actionTypes.REQUEST_SUCCESS:
      return state.set('loading', false).set('data', action.payload);
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    case actionTypes.RESET:
      return initialState;
    default:
      return state;
  }
}
